import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Login from './features/auth/pages/Login'
import SuperAdminRegister from './features/auth/pages/SuperAdminRegister'
import EmployeeRegister from './features/auth/pages/EmployeeRegister'
import ChangePassword from './features/auth/pages/ChangePassword'
import ProtectedRoute from './features/auth/components/ProtectedRoute'
import Dashboard from './features/dashboard/pages/Dashboard'

// Module pages
import Timesheet from './features/timesheet/pages/Timesheet'
import TimeOff from './features/time-off/pages/TimeOff'
import SalarySlips from './features/salary-slips/pages/SalarySlips'
import Announcements from './features/announcements/pages/Announcements'
import LeavePolicy from './features/leave-policy/pages/LeavePolicy'
import Holidays from './features/holidays/pages/Holidays'
import Attendance from './features/attendance/pages/Attendance'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register-admin" element={<SuperAdminRegister />} />

        {/* Protected Admin Route */}
        <Route
          path="/register-employee"
          element={
            <ProtectedRoute>
              <EmployeeRegister />
            </ProtectedRoute>
          }
        />

        {/* Protected Route - Change Password */}
        <Route
          path="/change-password"
          element={
            <ProtectedRoute>
              <ChangePassword />
            </ProtectedRoute>
          }
        />

        {/* Protected Routes - Dashboard */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* Protected Routes - Active Modules */}
        <Route
          path="/timesheet"
          element={
            <ProtectedRoute>
              <Timesheet />
            </ProtectedRoute>
          }
        />
        <Route
          path="/time-off"
          element={
            <ProtectedRoute>
              <TimeOff />
            </ProtectedRoute>
          }
        />
        <Route
          path="/salary-slips"
          element={
            <ProtectedRoute>
              <SalarySlips />
            </ProtectedRoute>
          }
        />
        <Route
          path="/announcements"
          element={
            <ProtectedRoute>
              <Announcements />
            </ProtectedRoute>
          }
        />
        <Route
          path="/leave-policy"
          element={
            <ProtectedRoute>
              <LeavePolicy />
            </ProtectedRoute>
          }
        />
        <Route
          path="/holidays"
          element={
            <ProtectedRoute>
              <Holidays />
            </ProtectedRoute>
          }
        />
        <Route
          path="/attendance"
          element={
            <ProtectedRoute>
              <Attendance />
            </ProtectedRoute>
          }
        />

        {/* Redirect root to dashboard */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        {/* 404 - Redirect to dashboard */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
